import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Notes from './notes';
import Bulletins from './bulletins';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId`} component={Notes} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/all`} component={Bulletins} />
    </Switch>
  </>
);

export default Routes;
